import { useState, useEffect, useRef } from "react";
import { SERVICES } from "./constants";

const ServiceCard = ({ service, index }) => {
  const Icon = service.icon;
  return (
    <div
      data-testid={`service-card-${service.id}`}
      className="service-card group bg-white rounded-2xl overflow-hidden shadow-md border border-stone-100 hover:border-forest-200"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className="h-56 w-full overflow-hidden relative image-container">
        <img
          src={service.image}
          alt={service.title}
          className="service-image w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-4 right-4 bg-forest-500/90 p-2 rounded-full">
          <Icon className="w-5 h-5 text-white" />
        </div>
      </div>
      <div className="p-6 space-y-3">
        <h3 className="font-serif text-xl text-forest-700 font-semibold">{service.title}</h3>
        <p className="text-stone-600 text-sm leading-relaxed">{service.description}</p>
      </div>
    </div>
  );
};

export default function ServicesSection() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} data-testid="services-section" className="py-20 md:py-32 bg-sand-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-forest-500 font-medium tracking-wider uppercase text-sm">What We Offer</span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-forest-700 font-bold mt-3 mb-4">Our Services</h2>
          <p className="text-stone-600 max-w-2xl mx-auto">
            From regular lawn maintenance to complete landscape transformations, we provide comprehensive outdoor services for your property.
          </p>
        </div>
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}>
          {SERVICES.map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
